<template>
  <div class="stoveTemper">
    <div class="wrapper">
      <div class="headerTop">
        <a-icon type="heat-map" /><span>料道和行列机</span>
      </div>
      <div class="table">
        <div class="tableHeader">
          <div v-for="item in listData.list" :key="item.index">
            <div class="listItem">{{ item }}</div>
          </div>
        </div>
        <div class="content">
          <div>
            <div v-for="item in listData.info.nameArr" :key="item.index">
              <div class="nameArrItem">{{ item }}</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.passage1TemArr" :key="item.index">
              <div class="currentArrItem">{{ item }}°c</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.passage2TemArr" :key="item.index">
              <div class="maxArrItem">{{ item }}°c</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.passage3TemArr" :key="item.index">
              <div class="mixArrItem">{{ item }}°c</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.passage4TemArr" :key="item.index">
              <div class="nameArrItem">{{ item }}°c</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.rev" :key="item.index">
              <div class="currentArrItem">{{ item }}</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.dripNum" :key="item.index">
              <div class="maxArrItem" v-if="item!==null">{{ item }}g</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.bottleWeight" :key="item.index">
              <div class="mixArrItem">{{ item }}</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.cutNum" :key="item.index">
              <div class="nameArrItem" v-if="item!==null">{{ item }}</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.feedNum" :key="item.index">
              <div class="currentArrItem" v-if="item!==null">{{ item }}</div>
            </div>
          </div>
          <div>
            <div v-for="item in listData.info.query" :key="item.index">
              <div class="query">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // listData: {
      //   list: [
      //     "名称",
      //     "料盆加热温度",
      //     "匀化加热温度",
      //     "冷2加热温度",
      //     "冷1加热温度",
      //     "机速",
      //     "滴料数",
      //     "瓶重量",
      //     "出料量",
      //     "滞留时间",
      //     "查询",
      //   ],
      //   ttt: {
      //     nameArr: [
      //       "L1",
      //       "L2",
      //       "L3",
      //       "L4",
      //       "L5",
      //       "L6",
      //       "L7",
      //       "L8",
      //       "L9",
      //       "L10",
      //       "L11",
      //       "L12",
      //       "L13",
      //       "L14",
      //       "L15",
      //       "L16",
      //     ],
      //     passage1TemArr: [
      //       "16",
      //       "21",
      //       "25",
      //       "35",
      //       "22",
      //       "12",
      //       "21",
      //       "23",
      //       "16",
      //       "21",
      //       "25",
      //       "35",
      //       "22",
      //       "12",
      //       "21",
      //       "23",
      //     ],
      //     passage2TemArr: [
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //     ],
      //     passage3TemArr: [
      //       "10",
      //       "15",
      //       "5",
      //       "15",
      //       "20",
      //       "30",
      //       "25",
      //       "40",
      //       "10",
      //       "15",
      //       "5",
      //       "15",
      //       "20",
      //       "30",
      //       "25",
      //       "40",
      //     ],
      //     passage4TemArr: [
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //     ],
      //     rev: [
      //       "110",
      //       "135",
      //       "54",
      //       "135",
      //       "220",
      //       "340",
      //       "255",
      //       "460",
      //       "170",
      //       "155",
      //       "54",
      //       "155",
      //       "620",
      //       "360",
      //       "265",
      //       "440",
      //     ],
      //     dripNum: [
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //     ],
      //     bottleWeight: [
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //     ],
      //     cutNum: [
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //     ],
      //     feedNum: [
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //       "35",
      //       "28",
      //       "45",
      //       "55",
      //       "46",
      //       "89",
      //       "78",
      //       "25",
      //     ],
      //     query: [
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //       "剪料数",
      //     ],
      //   },
      // },
    };
  },
  props:{
    listData:{
      type:Object,
    }
  },
  methods: {},
};
</script>
<style scoped>
.wrapper {
  color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #1f2b39;
  height: 460px;
  margin-top: 10px;
}
.headerTop {
  display: flex;
  align-items: center;
}
.headerTop span {
  font-size: 16px;
  padding-right: 30px;
  padding-left: 10px;
}
.tableHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-top: 10px;
  font-size: 12px;
  background-color: #343842;
  margin: 10px;
  padding-bottom: 5px;
}
.listItem {
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nameArrItem,
.maxArrItem,
.mixArrItem {
  width: 55px;
  height: 30px;
  color: #7b828b;
}
.currentArrItem {
  width: 40px;
  height: 30px;
  color: #ab383e;
}
.table {
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 400px;
}
.content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  overflow-y: scroll;
  position: absolute;
  right: -17px;
  overflow-x: hidden;
  height: 400px;
  padding-right: 17px;
}
.query {
  width: 55px;
  height: 30px;
  color: #215a93;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/list.vue